import React from "react";
import {
  View,
  Text,
  StyleSheet,
  useWindowDimensions,
  Platform,
} from "react-native";
import GlobalStyles from "./StylenColor"; // Adjust the path as necessary

const FilledMessage = ({ remainingTime, userName, employeeIdNum, quarter }) => {
  const { width } = useWindowDimensions();
  const isDesktopWeb = Platform.OS === "web" && width > 900;

  return (
    <View style={styles.container}>
      <Text
        style={[
          styles.messageText,
          isDesktopWeb && { fontSize: GlobalStyles.fontSize.lg },
        ]}
      >
        This questionnaire has already been filled for the current quarter:{" "}
        {quarter}.
      </Text>
      <Text
        style={[
          styles.userText,
          isDesktopWeb && { fontSize: GlobalStyles.fontSize.md },
        ]}
      >
        This questionnaire is filled by {userName} (ID: {employeeIdNum})
      </Text>
      <Text
        style={[
          styles.remainingText,
          isDesktopWeb && { fontSize: GlobalStyles.fontSize.sm },
        ]}
      >
        You can fill it:
      </Text>
      <Text
        style={[
          styles.remainingText,
          isDesktopWeb && { fontSize: GlobalStyles.fontSize.sm },
        ]}
      >
        {remainingTime && (
          <Text style={{ marginVertical: 10, color: "#17372a" }}>
            {` again in ${remainingTime}`}
          </Text>
        )}
      </Text>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    padding: 16,
    backgroundColor: GlobalStyles.GlobalBg.backgroundColor,
  },
  messageText: {
    fontSize: GlobalStyles.fontSize.lg,
    color: "black",
    textAlign: "center",
    marginBottom: 20,
    fontFamily: GlobalStyles.GlobalFont.fontFamily,
    paddingVertical: 1,
    paddingHorizontal: 15,
  },
  userText: {
    fontSize: GlobalStyles.fontSize.md,
    fontFamily: GlobalStyles.GlobalFont.fontFamily,
    color: "#333",
    textAlign: "center",
    marginBottom: 20,
    paddingVertical: 1,
    paddingHorizontal: 15,
  },
  remainingText: {
    fontSize: GlobalStyles.fontSize.md,
    color: "#333",
    textAlign: "center",
    fontFamily: GlobalStyles.inpFont.fontFamily,
    paddingVertical: 1,
    paddingHorizontal: 15,
  },
});

export default FilledMessage;
